module.exports = __webpack_public_path__ + "static/media/slider-3.5c3aa48f.jpeg";